import { FC } from 'react';
import { toast } from 'sonner';
import { SubmitButton } from '@/components/form/submit-button';
import { useForm } from '@/forms/hooks/use-form/use-form';
import { ImportHexnodeDeviceFieldValues } from '@/forms/schemas/import-hexnode-device/field-values';
import { importHexnodeDeviceFormSchema } from '@/forms/schemas/import-hexnode-device/schema';
import { useImportDeviceMutation } from '@/redux/api/endpoints/device-import';

export const ImportHexnodeDeviceForm: FC = () => {
  const [importDevice, { isLoading }] = useImportDeviceMutation();

  const handleSubmit = async (values: ImportHexnodeDeviceFieldValues) => {
    try {
      await importDevice({
        type: 'HEX_NODE_TABLET',
        tabletId: values.tabletId,
      }).unwrap();
      toast.success('HexNode tablet imported successfully');
    } catch {
      toast.error('Failed to import HexNode tablet');
    }
  };

  const { fieldItems, handleSubmit: onSubmit } = useForm({
    schema: importHexnodeDeviceFormSchema,
    onSubmit: handleSubmit,
  });

  return (
    <form className="flex flex-col gap-4" onSubmit={onSubmit}>
      {fieldItems}
      <SubmitButton
        disabled={isLoading}
        text={isLoading ? 'Importing...' : 'Import HexNode Tablet'}
      />
    </form>
  );
};
